import React from 'react';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import { Divider } from '@care/react-component-lib';
import { Icon24SuccessFilled } from '@care/react-embrace-icons';

export const getFeaturesGridItems = () => [
  {
    text: 'Browse background checked caregivers',
    showIcon: true,
  },
  {
    text: 'Post your job',
    showIcon: true,
  },
  {
    text: 'Message with candidates',
  },
  {
    text: 'Book last-minute sitters*',
  },
  {
    text: 'Discounts on everyday essentials**',
  },
  {
    text: 'Purchase additional background checks',
  },
];

const FeaturesGrid = () => {
  const theme = useTheme();
  const featuresGridItems = getFeaturesGridItems();

  return (
    <Box sx={{ px: 3, mt: { xs: 8, lg: 10 }, maxWidth: { sm: '537px', lg: '654px' } }}>
      <Typography variant="display3" sx={{ textAlign: 'center', margin: 0 }}>
        Browse for free&mdash;go Premium when you&apos;re ready to hire
      </Typography>

      <Grid
        container
        spacing={2}
        sx={{
          backgroundColor: { sm: theme.palette.care?.white },
          borderRadius: {
            xs: 6,
            md: 8,
          },
          alignItems: 'center',
          mt: 4,
          pt: 3,
          pb: 4,
          px: {
            sm: 2,
          },
        }}>
        <>
          <Grid item xs={6} md={7} />
          <Grid item xs={2} md={1} />
          <Grid sx={{ textAlign: 'center', padding: '0 !important' }} item xs={2}>
            <Typography
              sx={{
                fontWeight: 'bold',
                marginRight: { xs: '1px', sm: 0 },
              }}>
              Guest
            </Typography>
          </Grid>
          <Grid sx={{ textAlign: 'center', padding: '0 !important' }} item xs={2}>
            <Typography sx={{ fontWeight: 'bold', marginLeft: { xs: '2px', sm: 0 } }}>
              Premium
            </Typography>
          </Grid>
        </>

        {featuresGridItems.map(({ text, showIcon }) => (
          <Grid
            container
            item
            key={`features-grid-item-${text}`}
            sx={{
              display: 'flex',
              alignItems: 'center',
              minHeight: '65px',
            }}>
            <>
              <Grid item xs={6} md={7}>
                <Typography sx={{ width: { xs: '146px', md: '100%' } }} variant="body2">
                  {text}
                </Typography>
              </Grid>
              <Grid item xs={2} md={1} />
              <Grid
                item
                xs={2}
                sx={{ display: 'flex', justifyContent: 'center', paddingLeft: '0 !important' }}>
                {showIcon ? (
                  <Icon24SuccessFilled
                    size={24}
                    sx={{
                      '& path:first-of-type': {
                        fill: theme.palette.brand.main,
                      },
                    }}
                  />
                ) : (
                  <Divider
                    sx={{
                      width: '33px',
                      '&::before, &::after': {
                        borderTopColor: '#213f5f',
                      },
                    }}
                  />
                )}
              </Grid>
              <Grid
                item
                xs={2}
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'flex-end', sm: 'center' },
                  paddingLeft: { sm: '0 !important' },
                }}>
                <Icon24SuccessFilled
                  size={24}
                  sx={{
                    marginRight: { xs: '8px', sm: 0 },
                    '& path:first-of-type': {
                      fill: theme.palette.brand.main,
                    },
                  }}
                />
              </Grid>
            </>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturesGrid;
